import { Button, PositionedToggle, TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import { usePlaybookModalState } from '../PlaybookModalContext';
import { titleKeyByAssetType } from '../consts';
import type { PlaybookSearchResult } from '../types';
import { DraggableRow } from './DraggableRow';

export const InternalAssetRow = ({ id }: { id: string }) => {
  const { assets, setAssets } = usePlaybookModalState();
  const assetIndex = assets.findIndex((asset) => asset.assetId === id);
  const asset = assets[assetIndex];
  const item = asset.entity as PlaybookSearchResult;
  const toggleInternalAssetAutoSync = () => {
    const newAssetsArray = [...assets];
    newAssetsArray.splice(assetIndex, 1, {
      ...asset,
      autoSync: !asset.autoSync,
    });
    setAssets(newAssetsArray);
  };

  return (
    <DraggableRow
      asset={asset}
      entityType={asset.assetType}
    >
      <div className="flex-auto flex items-center justify-between gap-2.5 overflow-x-hidden">
        <div className="shrink flex items-center gap-2.5 overflow-x-hidden">
          <TextBase
            ellipsis
            label={item[titleKeyByAssetType[asset.assetType]]}
            color="text-ds-natural-600"
          />
        </div>
        <div className="flex items-center gap-3">
          <div className={classNames('hidden group-hover:block')}>
            <Button
              xSmall
              noPadding
              blue
              link
              label="Remove"
              onClick={() => {
                setAssets(
                  assets.filter(
                    (storeAsset) => storeAsset.assetId !== asset.assetId
                  )
                );
              }}
            />
          </div>
          <PositionedToggle
            checked={asset.autoSync}
            onChange={toggleInternalAssetAutoSync}
          />
        </div>
      </div>
    </DraggableRow>
  );
};
